import { connect } from 'react-redux';

import * as PartnerProfile from 'app/entities/PartnerProfile';
import * as Profile from 'app/entities/Profile';

import ExistingDev from './ExistingDev';

const TEMPORARY_ENTITY_NAME = 'new-partner-profile';

const createPartnerProfile = userData => async dispatch => {
  const createdEntity = await dispatch(
    PartnerProfile.actions.createPartnerProfile(userData)
  );
  await dispatch(Profile.actions.reloadCurrentProfile());

  if (PartnerProfile.selectors.isFailure(createdEntity)) {
    return;
  }
};

const mapStateToProps = state => {
  const currentProfile = Profile.selectors.all.currentProfile(state);
  const partnerProfile = PartnerProfile.selectors.all.first(state);
  // This is quite hacky but I couldn't find another way to do it.
  // Since the entity doesn't exist, we need to create a _fake_ one with the key TEMPORARY_ENTITY_NAME ('new-partner-profile')
  // If we get an error while saving, we need to get the data from the temporary entity.
  // We will only have a _real_ entity once we successfully send the data to the backend.
  const failedPartnerProfile = PartnerProfile.selectors.all.entityByCid(
    TEMPORARY_ENTITY_NAME,
    state
  );

  return {
    termsAccepted: Profile.selectors.hasAcceptedTerms(currentProfile),
    roles: PartnerProfile.selectors.roles(partnerProfile),
    jobTitle: PartnerProfile.selectors.jobTitle(partnerProfile),
    errorMessages: PartnerProfile.selectors.formError(failedPartnerProfile),
    isSaving: PartnerProfile.selectors.isSaving(failedPartnerProfile),
  };
};

const mapDispatchToProps = dispatch => ({
  createPartnerProfile(profileData) {
    dispatch(createPartnerProfile(profileData));
  },
});

const ExistingDevContainerExistingDeveloper = connect(
  mapStateToProps,
  mapDispatchToProps
)(ExistingDev);

export default ExistingDevContainerExistingDeveloper;
